import { LoginButton } from '@Components/LoginButton';
import { FlexColumn } from '@synqo/frontend-component-library';

interface NoAccessProps {
    message: string;
}

// @ai-generated 2026-10-12T14:25:59+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
export function NoAccess({ message }: NoAccessProps) {
    return (
        <FlexColumn>
            <p className="m-0">{message}</p>
            <LoginButton />
        </FlexColumn>
    );
}
